import { render, staticRenderFns } from "./agingTable.vue?vue&type=template&id=6e533a68&scoped=true"
import script from "./agingTable.vue?vue&type=script&lang=js"
export * from "./agingTable.vue?vue&type=script&lang=js"
import style0 from "./agingTable.vue?vue&type=style&index=0&id=6e533a68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e533a68",
  null
  
)

export default component.exports